module.exports = __webpack_public_path__ + "img/claas_thumbnail.8e1ab327.png";